<script>
import AddItem from "../watchlist/actions/AddItem.svelte";
</script>

<AddItem />